import React from "react";

import {
    Landmark,
    User,
    CreditCard,
    Building2,
    Smartphone
} from "lucide-react";

import "./BankForm.css";

function BankForm({

    profile,

    setProfile,

}) {

    const handleChange = (e) => {

        const { name, value } = e.target;

        setProfile({

            ...profile,

            bank: {

                ...profile.bank,

                [name]: value,

            },

        });

    };

    return (

        <div className="edit-card">

            <h2>

                Bank Details

            </h2>

            <div className="form-grid">

                <div className="input-group">

                    <label>

                        <Landmark size={16}/>

                        Bank Name

                    </label>

                    <input

                        type="text"

                        name="bankName"

                        value={profile?.bank?.bankName || ""}

                        onChange={handleChange}

                        placeholder="State Bank of India"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <User size={16}/>

                        Account Holder

                    </label>

                    <input

                        type="text"

                        name="accountHolder"

                        value={profile?.bank?.accountHolder || ""}

                        onChange={handleChange}

                        placeholder="Account Holder Name"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <CreditCard size={16}/>

                        Account Number

                    </label>

                    <input

                        type="text"

                        name="accountNumber"

                        value={profile?.bank?.accountNumber || ""}

                        onChange={handleChange}

                        placeholder="123456789012"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Building2 size={16}/>

                        IFSC Code

                    </label>

                    <input

                        type="text"

                        name="ifsc"

                        value={profile?.bank?.ifsc || ""}

                        onChange={handleChange}

                        placeholder="SBIN0001234"

                    />

                </div>

                <div className="input-group">

                    <label>

                        <Smartphone size={16}/>

                        UPI ID

                    </label>

                    <input

                        type="text"

                        name="upiId"

                        value={profile?.bank?.upiId || ""}

                        onChange={handleChange}

                        placeholder="name@oksbi"

                    />

                </div>

            </div>

        </div>

    );

}

export default BankForm;